export type ErrorPhase = 'silent' | 'warning' | 'error';

export class ErrorPhaseManager {
  private phase: ErrorPhase = 'silent';
  private phase1Timer: ReturnType<typeof setTimeout> | null = null;
  private phase2Timer: ReturnType<typeof setTimeout> | null = null;
  private active = false;

  constructor(
    private config: {
      phase1Duration: number;
      phase2Duration: number;
      onPhaseChange: (phase: ErrorPhase) => void;
    },
  ) {}

  start(): void {
    if (this.active) return;
    this.active = true;
    this.phase = 'silent';
    this.config.onPhaseChange('silent');

    this.phase1Timer = setTimeout(() => {
      this.phase = 'warning';
      this.config.onPhaseChange('warning');

      this.phase2Timer = setTimeout(() => {
        this.phase = 'error';
        this.config.onPhaseChange('error');
      }, this.config.phase2Duration);
    }, this.config.phase1Duration);
  }

  reset(): void {
    if (this.phase1Timer) {
      clearTimeout(this.phase1Timer);
      this.phase1Timer = null;
    }
    if (this.phase2Timer) {
      clearTimeout(this.phase2Timer);
      this.phase2Timer = null;
    }
    this.phase = 'silent';
    this.active = false;
  }

  getPhase(): ErrorPhase {
    return this.phase;
  }

  isActive(): boolean {
    return this.active;
  }
}
